import { boolean, nullable, object } from 'superstruct';

import { ListResourceDto } from '@adflow/shared/util-data';
import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import {
	AddColumnTemplateDto,
	EditColumnTemplateDto,
} from './add-column-template.dto';
import { ListColumnTemplateQueryDto } from './list-column-templates-query.dto';
import { ViewColumnTemplateDto } from './view-column-template.dto';

const p = adflowApiSchema.prefix('column-template');

export const ListColumnTemplates = p.get('', {
	req: object({
		query: ListColumnTemplateQueryDto,
	}),
	res: ListResourceDto(ViewColumnTemplateDto),
});

export const GetDefaultColumnTemplate = p.get('default', {
	req: object({
		query: ListColumnTemplateQueryDto,
	}),
	/** `null` when there is no default column template. */
	res: nullable(ViewColumnTemplateDto),
});

export const GetColumnTemplate = p.get(':columnTemplateId', {
	req: object({
		params: object({ columnTemplateId: parsableInteger() }),
	}),
	res: ViewColumnTemplateDto,
});

export const AddColumnTemplate = p.post('', {
	req: object({
		body: AddColumnTemplateDto,
	}),
	res: ViewColumnTemplateDto,
});

export const EditColumnTemplate = p.patch(':columnTemplateId', {
	req: object({
		params: object({ columnTemplateId: parsableInteger() }),
		body: EditColumnTemplateDto,
	}),
	res: ViewColumnTemplateDto,
});

export const DeleteColumnTemplate = p.delete(':columnTemplateId', {
	req: object({
		params: object({ columnTemplateId: parsableInteger() }),
	}),
	res: boolean(),
});
